import React, { useState } from 'react';
import './PaymentMethodSelector.css';

const PaymentMethodSelector = ({ onPaymentSelect, onBack }) => {
  const [selectedMethod, setSelectedMethod] = useState('');

  const paymentMethods = [
    {
      id: 'card',
      name: 'Credit/Debit Card',
      icon: '💳',
      description: 'Paga con tarjeta'
    },
    {
      id: 'cash',
      name: 'Cash',
      icon: '💰',
      description: 'Pagar al pick up'
    },
    {
      id: 'digital',
      name: 'Digital Wallet',
      icon: '📱',
      description: 'Apple Pay, Google Pay'
    },
    {
      id: 'paypal',
      name: 'PayPal',
      icon: 'P',
      description: 'Pagar con PayPal'
    }
  ];

  const handleSelect = (methodId) => {
    setSelectedMethod(methodId);
  };

  const handleContinue = () => {
    if (selectedMethod) {
      onPaymentSelect(selectedMethod);
    }
  };

  return (
    <div className="payment-method-selector">
      <div className="selector-header">
        <h2>Elija un método de pago</h2>
        <p>Selecciona cómo quieres pagar</p>
      </div>

      <div className="payment-options">
        {paymentMethods.map(method => (
          <div
            key={method.id}
            className={`payment-option ${selectedMethod === method.id ? 'selected' : ''}`}
            onClick={() => handleSelect(method.id)}
          >
            <div className="option-icon">{method.icon}</div>
            <div className="option-info">
              <h3 className="option-name">{method.name}</h3>
              <p className="option-description">{method.description}</p>
            </div>
            <div className="option-selector">
              {selectedMethod === method.id ? (
                <div className="selected-indicator">✓</div>
              ) : (
                <div className="unselected-indicator"></div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="selector-actions">
        <button className="action-btn secondary" onClick={onBack}>
          Back to Cart
        </button>
        <button 
          className="action-btn primary"
          onClick={handleContinue}
          disabled={!selectedMethod}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default PaymentMethodSelector;